import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.8335 2.5C4.45278 2.5 3.3335 3.61929 3.3335 5V15C3.3335 16.3807 4.45278 17.5 5.8335 17.5H14.1668C15.5475 17.5 16.6668 16.3807 16.6668 15V8.33333C16.6668 5.11167 14.0552 2.5 10.8335 2.5H5.8335ZM5.00016 5C5.00016 4.53976 5.37326 4.16667 5.8335 4.16667H10.0002V6.66667C10.0002 8.04738 11.1195 9.16667 12.5002 9.16667H15.0002V15C15.0002 15.4602 14.6271 15.8333 14.1668 15.8333H5.8335C5.37326 15.8333 5.00016 15.4602 5.00016 15V5ZM14.9168 7.5C14.5854 5.86739 13.2994 4.58142 11.6668 4.25002V6.66667C11.6668 7.1269 12.0399 7.5 12.5002 7.5H14.9168Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}